import { CloneWorkspaceSubTitle } from 'src/legacy/components/Onboarding';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BrandAvatar } from 'src/legacy/components/UI/Avatars/BrandAvatar';
import { useOnboardingQueryParams } from 'src/routes/onboarding/setup/hooks/useOnboardingQueryParams';
import { useGetCloneableStatusQuery } from 'src/services/api';

export const LegacyOnboardingPageHeader = ({
  title,
  subtitle,
}: {
  title?: string;
  subtitle?: string;
}) => {
  const { workspaceTemplateId, workspaceTemplateName } =
    useOnboardingQueryParams();

  const { data: cloneableStatusData } = useGetCloneableStatusQuery(
    workspaceTemplateId ?? '',
    {
      skip: workspaceTemplateId === undefined,
    },
  );

  const showCloningText = Boolean(
    cloneableStatusData?.isCloneable && workspaceTemplateId,
  );

  return (
    <>
      <BrandAvatar />
      <div className="mt-3 mb-10 text-center px-4 sm:px-0">
        {title && <BaseTypography fontType="18Medium">{title}</BaseTypography>}
        {subtitle && (
          <div className="mt-0.5">
            <BaseTypography className="text-gray-small">
              {subtitle}
            </BaseTypography>
            {showCloningText && (
              <CloneWorkspaceSubTitle templateName={workspaceTemplateName} />
            )}
          </div>
        )}
      </div>
    </>
  );
};
